import React, { useEffect, useContext, useState } from 'react';
import styled from 'styled-components';
import {
  WidgetPrintHeader,
  Container,
  BodyPrint,
} from '@mummssoftware/common-ui';
import { ENTITY_PATIENT_CARE_GIVER } from '@mummssoftware/global-context/PNCounter/constants';
import { showPrintNotes } from '@mummssoftware/utils/utils';
import defaults from '../../translations/en.json';
import { BereavementContext } from '../../context';
import { CareGiverTable } from './CareGiverTable';
import { PrintNotes } from './PrintNotes';

// way to get next page break with global printing
const PageBreak = styled.div`
  @media print {
    visibility: hidden;
  }
`;

type BereavementPrintProps = {
  onWidgetReady?: (arg: mumms.ComponentName) => void;
  careGiversInfo: any;
};

export const BereavementPrint = ({
  onWidgetReady,
  careGiversInfo,
}: BereavementPrintProps) => {
  const { printConfig, observation, patient, agency } = useContext(
    BereavementContext,
  );

  const [bereavementNotes, setBereavementNotes] = useState<any>(null);

  const showNotes = showPrintNotes(printConfig);

  useEffect(() => {
    // make API calls when needed => only when printing
    if (showNotes) {
      getNotes();
    }
  }, [showNotes]);

  // todo strategy printing for cross Platform and patientNumber
  const getNotes = async () => {
    const pnNotes =
      observation &&
      (await observation.getWidgetPnNotes(
        patient?.patientNumber as string,
        agency as string,
        ENTITY_PATIENT_CARE_GIVER,
      ));

    setBereavementNotes(pnNotes);
  };

  // on component did mount
  useEffect(() => {
    // callback to alert dashboard the view is ready
    onWidgetReady && onWidgetReady('Bereavement' as mumms.ComponentName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <BodyPrint>
        <WidgetPrintHeader title={defaults.title} />
        <CareGiverTable careGiversInfo={careGiversInfo} />
        <PrintNotes
          careGiversInfo={careGiversInfo}
          bereavementNotes={bereavementNotes}
        />
      </BodyPrint>
      <PageBreak />
    </Container>
  );
};
